import React from 'react';
import { Input } from '../../../../components/ui/input';
import { Textarea } from '../../../../components/ui/textarea';
import { AiButton, Field, inputCls, wordCount } from '../shared';

export const validate = (wf) => {
  if (!wf.article?.title?.trim()) return 'The draft needs a title.';
  if (wordCount(wf.article?.content) < 150) return 'The draft is too short — generate or write at least 150 words.';
  return null;
};

const StepDraft = ({ wf, setArticle, runAi, ai }) => {
  const a = wf.article || {};
  const running = ai.running && ai.action === 'draft';
  const hasDraft = !!a.content?.trim();

  const write = async () => {
    if (hasDraft && !confirm('Replace the current draft with a fresh AI draft?')) return;
    await runAi('draft', {}, (txt) => setArticle({ content: txt }));
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 flex-wrap">
        <AiButton onClick={write} running={running} label={hasDraft ? 'Rewrite first draft with AI' : 'Write first draft with AI'} runningLabel="Writing draft…" testId="draft-generate-btn" />
        <span className="text-xs text-ink-3" data-testid="draft-word-count">{wordCount(a.content)} words</span>
      </div>
      <Field label="Title" required testId="draft-title-field">
        <Input value={a.title || ''} onChange={(e) => setArticle({ title: e.target.value })} className={`${inputCls} h-12 text-base`} placeholder="Generated from the draft, or write your own" data-testid="draft-title-input" />
      </Field>
      <Field label="Draft (Markdown-lite)" required hint="## headings, - lists, **bold**. This flows into every later step." testId="draft-content-field">
        <Textarea value={a.content || ''} onChange={(e) => setArticle({ content: e.target.value })} rows={26} className={`${inputCls} font-mono text-sm`} readOnly={running} data-testid="draft-content-input" />
      </Field>
    </div>
  );
};

export default StepDraft;
